import { lagunaTemplate } from "./templates/laguna";
import { morrowTemplate } from "./templates/morrow";
import { sharedLagunaShopTemplates } from "./templates/sharedLagunaShopTemplates";
import type { SiteTemplateDefinition } from "./types";

export {
    createSharedLagunaShopTemplate,
    sharedLagunaShopTemplates,
} from "./templates/sharedLagunaShopTemplates";
export { SHOP_VERTICAL_TEMPLATE_CODES } from "./shopVerticalCatalog";

export const allShopTemplates: SiteTemplateDefinition[] = [
    lagunaTemplate,
    morrowTemplate,
    ...sharedLagunaShopTemplates,
];

const shopTemplatesByCode = new Map(
    allShopTemplates.map((template) => [template.manifest.code, template] as const),
);

if (shopTemplatesByCode.size !== allShopTemplates.length) {
    throw new Error("Shop template registry contains duplicate template codes.");
}

export const shopTemplates: SiteTemplateDefinition[] = allShopTemplates.filter(
    (template) => template.manifest.visibility !== "private",
);

export const defaultShopTemplate = lagunaTemplate;

export function findShopTemplate(code?: string | null): SiteTemplateDefinition | undefined {
    return code ? shopTemplatesByCode.get(code) : undefined;
}

export function getShopTemplate(code?: string | null): SiteTemplateDefinition {
    if (!code) {
        return defaultShopTemplate;
    }

    const template = findShopTemplate(code);

    if (!template) {
        throw new Error(`Unknown shop template renderer: ${code}`);
    }

    return template;
}
